import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Avatar, AVATAR_SIZES } from 'ui/avatar';
import { H4, spacing } from 'ui/theme';
import { selectFirstName, selectLastName, selectUserAvatarUrl } from 'core/userContext/selectors';

const Container = styled.div`
  display: flex;
  gap: ${spacing.half};
  align-items: center;
`;

const StyledAvatar = styled(Avatar)`
  flex-shrink: 0;
`;

const StyledName = styled(H4)`
  margin-top: 0;
`;

export const getTimeOfDayText = () => {
  const currentHour = new Date().getHours();
  if (currentHour >= 5 && currentHour < 12) {
    return 'morning';
  } else if (currentHour >= 12 && currentHour < 17) {
    return 'afternoon';
  } else {
    return 'evening';
  }
};

export const UserGreeting = () => {
  const firstName = useSelector(selectFirstName);
  const lastName = useSelector(selectLastName);
  const userAvatarUrl = useSelector(selectUserAvatarUrl) || '';

  return (
    <Container>
      <StyledAvatar
        firstName={firstName}
        lastName={lastName}
        imgSrc={userAvatarUrl}
        size={AVATAR_SIZES.MEDIUM}
      />
      <StyledName>
        Good {getTimeOfDayText()}, {firstName}
      </StyledName>
    </Container>
  );
};
